import { ProductMultimediaLine } from 'Components/lines/product-multimedia-line/ProductMultimediaLine';
export default ProductMultimediaLine;
